import DeleteIcon from '@mui/icons-material/Delete';
import { Chip, TextField } from '@mui/material';
import React from 'react';

interface FileDisplayProps {
  value?: string;
  label?: string;
  disabled?: boolean;
  onRemove: () => void;
}

export const FileDisplay: React.FC<FileDisplayProps> = ({
  value,
  label,
  disabled = false,
  onRemove,
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className="text-field-wrapper">
      <TextField
        fullWidth
        label={label}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: true,
          inputComponent: () => (
            <Chip
              label={value}
              onClick={onRemove}
              onDelete={onRemove}
              deleteIcon={<DeleteIcon />}
              variant="outlined"
            />
          ),
        }}
        sx={{
          '& .MuiInput-underline:before': { borderBottom: 'none' },
          '& .MuiInput-underline:after': { borderBottom: 'none' },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
          '& .MuiInput-underline.Mui-focused:after': { borderBottom: 'none' },
        }}
      />
    </div>
  );
};
